import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AbModelo } from 'app/abstract/full-pages/locker/modelo.abstract';

@Injectable({ providedIn: 'root' })
export class ModeloService extends AbModelo {

  constructor(http: HttpClient) {
    super(http);
  }

  public getAllModelosBiccateca(): Observable<any> {
    return this.getAll(`modelos/biccateca`);
  }

  public getFisrtModeloLockerPorNome(nome: string): any {
    return this.get(`modelos/nomeLocker/${nome}/`);
  }
}